export function setAccessToken(access_token) {
  sessionStorage.setItem('access_token', access_token);
}

export function getAccessToken() {
  return sessionStorage.getItem('access_token');
}

export function removeAccessToken() {
  sessionStorage.removeItem('access_token');
}

export function setProfile(name, color, roles) {
  sessionStorage.setItem('profile_name', name);
  sessionStorage.setItem('profile_color', color);
  sessionStorage.setItem('profile_roles', Object.values(roles ?? {}).join(', '));
}

export function getProfile() {
  return {
    name: sessionStorage.getItem('profile_name'),
    color: sessionStorage.getItem('profile_color'),
    roles: sessionStorage.getItem('profile_roles'),
  };
}

export function getRoles() {
  const roles = sessionStorage.getItem('profile_roles');
  return roles ? roles.split(', ') : [];
}

export function removeProfile() {
  sessionStorage.removeItem('profile_name');
  sessionStorage.removeItem('profile_color');
  sessionStorage.removeItem('profile_roles');
}

export function setApiKey(apiKey) {
  sessionStorage.setItem('main_api_key', apiKey);
}

export function getApiKey() {
  return sessionStorage.getItem('main_api_key');
}

export function removeApiKey() {
  sessionStorage.removeItem('main_api_key');
}

export function removeAllData() {
  removeAccessToken();
  removeApiKey();
  removeProfile();
}

export function setLocale(locale) {
  localStorage.setItem('locale', locale);
}

export function getLocale() {
  return localStorage.getItem('locale') || 'en';
}

export function setTheme(theme) {
  localStorage.setItem('theme', theme === 'dark' ? 'true' : 'false');
}

export function getTheme() {
  return localStorage.getItem('theme') === 'true' ? 'dark' : 'light';
}

export function setTimezone(timezone) {
  localStorage.setItem('timezone', timezone);
}

export function getTimezone() {
  return localStorage.getItem('timezone') || 'UTC';
}

interface DashboardSettings {
  welcome: boolean;
  alerts: boolean;
}

export function getDashboardSettings(): DashboardSettings {
  const raw = localStorage.getItem('dashboard');
  const value = raw ? parseInt(raw, 10) : 1;

  return {
    welcome: (value & 1) === 1,
    alerts: (value & 2) === 2,
  };
}

export function setDashboardSettings(settings: DashboardSettings) {
  let value = 0;

  if (settings.welcome) value |= 1; // set bit 0
  if (settings.alerts) value |= 2;  // set bit 1

  localStorage.setItem('dashboard', value.toString());
}